import React, { useEffect, useRef } from "react";

export default function ExamFlowDialog({ title, message, actions, onClose }) {
  const closeButton = useRef(null);
  useEffect(() => { closeButton.current?.focus(); }, []);
  return (
    <div className="ql-dialog-overlay" role="presentation">
      <section className="ql-dialog ql-exam-flow-dialog" role="dialog" aria-modal="true" aria-labelledby="exam-flow-dialog-title">
        <div className="ql-dialog-header">
          <div id="exam-flow-dialog-title" className="ql-dialog-title">{title}</div>
          <button ref={closeButton} type="button" className="ql-dialog-close" onClick={onClose} aria-label="Fermer">&times;</button>
        </div>
        <div className="ql-dialog-body">{message}</div>
        <div className="ql-dialog-footer">
          {actions.map((action) => <button key={action.label} type="button" className={action.primary ? "ql-btn ql-btn-primary" : "ql-btn ql-btn-outline"} onClick={action.onClick} disabled={action.disabled}>{action.label}</button>)}
        </div>
      </section>
    </div>
  );
}
